import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Error no controlado en la interfaz:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-bone flex items-center justify-center p-6">
          <div className="max-w-md text-center bg-card border border-petroleum/10 rounded-2xl p-8 shadow-lg">
            <AlertTriangle className="w-8 h-8 text-terracotta mx-auto mb-3" strokeWidth={1.5} />
            <h1 className="font-heading text-xl font-bold text-charcoal">Algo salió mal en esta pantalla</h1>
            <p className="text-sm text-charcoal/60 mt-2">
              No pudimos mostrar esta sección, probablemente por un dato con un formato inesperado. Tu información no se perdió.
            </p>
            <button
              onClick={() => { window.location.href = "/"; }}
              className="mt-5 bg-petroleum text-white rounded-full px-5 py-2 text-sm font-medium hover:bg-petroleum/90 transition-colors"
            >
              Volver al inicio
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
